<template>
  <gj-input
    v-model="valueMap"
    :style="{width}"
    isEnter
    clearable
    :placeholder="placeholder"
    @change="change">
    <template #suffix>
      <slot name="suffix">
      </slot>
    </template>
  </gj-input>
</template>

<script>
  
  export default {
    name: "gj-lazy-input",
    props: {
      width: {
        type: String,
        default: '100px'
      },
      placeholder: {},
      value: {}
    },
    watch: {
      value: {
        handler: function (val) {
          if (val != this.valueMap) {
            this.valueMap = val
          }
        },
        immediate: true,
      },
    },
    data () {
        return {
            valueMap: ""
        }
    },
    methods: {
        change() {
            this.$emit("input", this.valueMap)
        }
    }
  }
</script>

<style scoped>
  .el-icon-search {
    cursor: pointer;
  }
</style>
